module.exports = __webpack_public_path__ + "static/media/rightAngleTriangle4.6950179d.svg";